import {
  issueViewerPrimaryQueryKey,
  preheatIssueViewerPrimary,
} from '@github-ui/preheat-issues-manager/issue-viewer-query'
import {useCachePreheatTask} from '@github-ui/preheat-issues-manager/use-cache-preheat'
import {getQueryClient} from '@github-ui/query-client'
import {useAnalytics} from '@github-ui/use-analytics'
import {useCallback, useMemo} from 'react'

import {issueViewerSecondaryViewQueryOptions} from '../components/fetch-issue-viewer-secondary-view'

type UseIssueViewerDataPreheatProps = {
  owner: string
  repo: string
  number: number
  allowedOwner?: string
  source: string
  enabled?: boolean
}

export function useIssueViewerDataPreheat({
  owner,
  repo,
  number,
  allowedOwner,
  source,
  enabled = true,
}: UseIssueViewerDataPreheatProps) {
  const {sendAnalyticsEvent} = useAnalytics({optional: true})
  const secondaryQueryOptions = useMemo(
    () =>
      issueViewerSecondaryViewQueryOptions({
        owner,
        repo,
        number,
        markAsRead: false,
        sendAnalyticsEvent,
        preheat: true,
        preheatSource: source,
      }),
    [number, owner, repo, sendAnalyticsEvent, source],
  )
  const preheatSecondaryQuery = useCallback(
    () => getQueryClient().prefetchQuery(secondaryQueryOptions),
    [secondaryQueryOptions],
  )
  const primaryQueryKey = useMemo(
    () => issueViewerPrimaryQueryKey({owner, repo, number, allowedOwner}),
    [owner, repo, number, allowedOwner],
  )
  const preheatPrimaryQuery = useCallback(
    () => preheatIssueViewerPrimary({owner, repo, number, allowedOwner, source}),
    [owner, repo, number, allowedOwner, source],
  )

  useCachePreheatTask({
    key: JSON.stringify(primaryQueryKey),
    task: preheatPrimaryQuery,
    enabled,
    highPriority: true,
  })
  useCachePreheatTask({
    key: JSON.stringify(secondaryQueryOptions.queryKey),
    task: preheatSecondaryQuery,
    enabled,
  })
}
